import { withNamespaces } from "react-i18next";
import { useMemo, useState } from "react";
import { withRouter } from "react-router-dom";
import PageContent from "../../../components/page-content";
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";
import Navigator from "src/components/Navigator";

import TabIncidentContent from "./tabs-contents/incidents";
import TabDataSubjectContent from "./tabs-contents/data-subjects";
import TabProcessingActivityContent from "./tabs-contents/processing-activities";
import AiGovernanceDashboard from "../software/tabs-content/ai-governance-dashboard";
import TabTomsDashboardContent from "./tabs-contents/toms";

const TAB_CRUMB_TITLES = {
	incidents: "Incidents",
	"data-subjects": "Data Subjects Request",
	"processing-activities": "Processing Activities",
	"ai-governance-dashboard": "AI Governance",
	toms: "TOMs",
};

const Dashboard = (props) => {
	const {
		t
	} = props;

	const [activeTab, setActiveTab] = useState('incidents');

	const breadCrumbs = useMemo(() => {
		const crumbs = [
			{
				title: "SIP",
				link: "/admin/data-protection/dashboard",
			},
			{
				title: "Dashboard",
				link: "/admin/data-protection/dashboard",
			},
		];

		const tabTitle = TAB_CRUMB_TITLES[activeTab];
		if (tabTitle) {
			crumbs.push({
				title: tabTitle,
				link: "#",
			});
		}

		return crumbs;
	}, [activeTab]);

	const renderActiveTabContent = () => {
		switch(activeTab){
			case 'incidents':
				return <TabIncidentContent/>;
			case 'data-subjects':
				return <TabDataSubjectContent />;
			case 'processing-activities':
				return <TabProcessingActivityContent />
			case 'ai-governance-dashboard':
				return <AiGovernanceDashboard />
			case 'toms':
				return <TabTomsDashboardContent />
			default:
				return null;
		}
	}

	return (
		<PageContent classNames="data-protection-hardware-list-page">
			<Container fluid>
				<Row>
					<Col lg="12" className="mb-4">
						<Navigator
							pageTitle="Dashboard"
							breadCrumbs={breadCrumbs}
						/>
					</Col>
				</Row>

				<Row>
					<Col lg={12}>
					<div style={{
							backgroundColor: '#D1D2D6',
						}}>
						<Nav tabs className="custom-style-1">
							<NavItem>
								<NavLink className={activeTab === 'incidents' ? 'active': ''}
									onClick={() => setActiveTab('incidents')}>
									{t("Incidents")}
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink className={activeTab === 'data-subjects' ? 'active': ''}
									onClick={() => setActiveTab('data-subjects')}>
									{t("Data Subjects Request")}
								</NavLink>
							</NavItem>

							<NavItem>
								<NavLink className={activeTab === 'processing-activities' ? 'active': ''}
									onClick={() => setActiveTab('processing-activities')}>
									{t("Processing Activites")}
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink className={activeTab === 'ai-governance-dashboard' ? 'active': ''}
									onClick={() => setActiveTab('ai-governance-dashboard')}>
									{t("AI Governance")}
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink className={activeTab === 'toms' ? 'active': ''}
									onClick={() => setActiveTab('toms')}>
									{t("TOM")}
								</NavLink>
							</NavItem>
						</Nav>
						</div>
					</Col>
				</Row>

				<Row className="mt-3">
					<Col lg={12}>
						{ renderActiveTabContent() }
					</Col>
				</Row>
			</Container>
		</PageContent>
	);
}	

export default withNamespaces()(
	withRouter(
		Dashboard
	)
);
